/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { Supplier } from './Supplier';
import {
    SupplierFromJSON,
    SupplierFromJSONTyped,
    SupplierToJSON,
    SupplierToJSONTyped,
} from './Supplier';

/**
 * 
 * @export
 * @interface ResponseSupplier
 */
export interface ResponseSupplier {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseSupplier
     */
    result: ResponseResult;
    /**
     * 
     * @type {Supplier}
     * @memberof ResponseSupplier
     */
    data: Supplier;
}

/**
 * Check if a given object implements the ResponseSupplier interface.
 */
export function instanceOfResponseSupplier(value: object): value is ResponseSupplier {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseSupplierFromJSON(json: any): ResponseSupplier {
    return ResponseSupplierFromJSONTyped(json, false);
}

export function ResponseSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': SupplierFromJSON(json['data']),
    };
}

export function ResponseSupplierToJSON(json: any): ResponseSupplier {
    return ResponseSupplierToJSONTyped(json, false);
}

export function ResponseSupplierToJSONTyped(value?: ResponseSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': SupplierToJSON(value['data']),
    };
}

